module.exports = __webpack_public_path__ + "img/icon-shareset.158ca5ca.png";